import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type PropsWithChildren, useState } from "react";
import { AuthSessionProvider } from "@/app/auth/session";
import { ThemeProvider } from "@/app/theme/ThemeProvider";
import { isHttpError } from "@/lib/api/http";

export function AppProviders({ children }: PropsWithChildren) {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						staleTime: 20_000,
						refetchOnWindowFocus: false,
						retry: (failureCount, error) => {
							if (isHttpError(error) && error.status >= 400 && error.status < 500) {
								return false;
							}
							return failureCount < 3;
						},
					},
				},
			}),
	);

	return (
		<QueryClientProvider client={queryClient}>
			<ThemeProvider>
				<AuthSessionProvider>{children}</AuthSessionProvider>
			</ThemeProvider>
		</QueryClientProvider>
	);
}
